export const stringsKey = "MessageLanguageRow";
export const englishStrings = {
	warningCardTitle: "Warning",
	variablesMessageSegmentWarning:
		"The number of segments & characters could change depending on the value of your variables.",
	removeMessageToolTip: "Remove Message",
	badVariableMessageWarning:
		"An included variable may be formatted incorrectly. Check your variable names before continuing",
};
